import React from 'react';
import CardIcon from "../../assets/benfit/flag-2-fill.svg";
import "./Benefit.css"
import useIntersectionObserver from "../customHooks/useIntersectionObserver.js";
const Benefit = () => {
    const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <section className={`grid-card-section ${isVisible ? "section-animation" : ""}`}
            ref={ref}
            id="three">
            <div className="container">
                <div className="row carder">
                    <div className="content-tag">
                        <h2 className='colored-text-benefit'>Benefits</h2>
                    </div>
                    <div className="grid-card-heading">
                        <h2>Revolutionary Features of Agent Scrum </h2>
                        <p>Enhancing team efficiency, Scrum compliance, and sprint predictability through intelligent automation, human oversight, and actionable insights</p>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="card">
                            <img src="https://www.nexastack.ai/hubfs/thumb-up-fill.svg" alt="card-icon" className="card-div-image" />
                            <h3> Seamless Human-AI Collaboration</h3>
                            <p>
                                Agent Scrum balances intelligent automation with human oversight through configurable workflows and flexible intervention points for optimal Scrum execution
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="card">
                            <img src="https://www.nexastack.ai/hubfs/global-fill.svg" alt="card-icon" className="card-div-image" />
                            <h3> Smart Approval Workflows</h3>
                            <p>
                                Define custom approval checkpoints with escalation paths, allowing teams to maintain governance while preserving agility in decision-making processes
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row carder">
                    <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                        <div className="card">
                            <img src={CardIcon} alt="card-icon" className="card-div-image" />
                            <h3> Interactive Conversation Interfaces </h3>
                            <p>
                                Engage with Agent Scrum through intuitive voice or text chat for real-time collaboration and faster decision-making during Scrum activities
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                        <div className="card">
                            <img src={CardIcon} alt="card-icon" className="card-div-image" />
                            <h3> Context-Aware Human Handoff </h3>
                            <p>
                                Intelligently identifies complex or sensitive tasks requiring human insight and automatically routes them to appropriate team members for resolution
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                        <div className="card">
                            <img src={CardIcon} alt="card-icon" className="card-div-image" />
                            <h3> Adaptive Agent Behavior Settings </h3>
                            <p>
                                Fine-tune autonomy levels based on team roles and preferences, with continuous learning from feedback to match your Scrum maturity
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                        <div className="card">
                            <img src={CardIcon} alt="card-icon" className="card-div-image" />
                            <h3>Continuous Feedback-Driven Improvement </h3>
                            <p>
                                Evolves through team feedback from interactions and retrospectives, refining recommendations to better align with your Agile practices over time
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Benefit;
